export default __webpack_public_path__ + "static/media/gift.797d98b1.webp";